import axios from 'axios'

const MemoService = {
  async get (params = {}) {
    return axios.get('rsm/memos', { params })
  },

  async histories (params = {}) {
    return axios.get('rsm/reports/memos', { params })
  },

  async show (id) {
    return axios.get(`rsm/memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('rsm/memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rsm/memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rsm/memos/${data.id}`, { data })
  }
}

export default MemoService
